import { createSlice } from "@reduxjs/toolkit";
import {
  EditAddTask,
  getAddTaskFormFieldsJson,
  PostAddTask,
} from "./AddTaskActions";
import { IAddTaskSlice } from "../../models/agent/Tasks/addTask";
const initialState: IAddTaskSlice = {
  addTaskFormFieldsJson: null,
  addTaskResponse: null,
  editTaskResponse: null,
};
const addTaskSlice = createSlice({
  name: "addTask",
  initialState: initialState,
  reducers: {
    setAddTaskFormFieldsJson: (state, { payload }) => {
      state.addTaskFormFieldsJson = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAddTaskFormFieldsJson.fulfilled,
      (state, { payload }) => {
        state.addTaskFormFieldsJson = payload.data;
      }
    );
    builder.addCase(PostAddTask.fulfilled, (state, { payload }) => {
      state.addTaskResponse = payload.data;
    });
    builder.addCase(EditAddTask.fulfilled, (state, { payload }) => {
      state.editTaskResponse = payload.data;
    });
  },
});

export default addTaskSlice.reducer;
export const { setAddTaskFormFieldsJson } = addTaskSlice.actions;
